<template>
  <div style="width: 100%">
    <div
      v-if="
        limsds_userDetails.userEmail != null &&
        limsds_userDetails.userEmail != ''
      "
    >
      <div v-show="showAll" style="float: left; width: 13%">
        <v-row dense>
          <v-col sm="12">
            <SiteUnitAreaTree
              v-on:input="siteUpdate($event)"
              :selectedItem.sync="selectedItem"
              :updateItem="updateItem"
              :selSiteName="defaultValues.site"
              :userArea="UnitArea"
            ></SiteUnitAreaTree>
          </v-col>
        </v-row>
      </div>
      <div v-show="showAll">
        
        <v-row dense>
          <v-col sm="2" class="ArrivalHeaderItem">
            {{ defaultValues.site }} Samples <br />
            {{ CurrentDateTime }} CST
          </v-col>
          <v-col sm="1" align="center" justify="center">
             <v-select
              solo
              hide-details
              dense
              label="Favorite"
              :items="favoriteList"
              item-text="fav_name"
              item-value="fav_id"
              v-model="selectedFav"
              @input="fillBySelectedFav()"
            ></v-select>
            <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <label class="LegendMenuItem">Legend</label>
              </div>
            </template>
              <div>
                <font color="black"
                  ><b>
                    Any Sample Point not collectted within past 30 days</b
                  ></font
                >
              </div>
              <div>
                <font color="black"
                  ><b>must be found through the search page.<br /></b
                ></font>
              </div>
              <div class="NewArrivalsLegend">
                Arrived within previous 30 minutes<br />
              </div>
              <div class="OldArrivalsLegend">
                Arrived within previous 2 hours <br />
              </div>
              <div class="OlderArrivalsLegend">
                Arrived within previous 12 hours <br />
              </div>
              <div style="display: inline-flex">
                <!-- <v-img
                  height="15"
                  width="15"
                  :src="require('@/apps/limsds/images/warningsign1.png')"
                ></v-img> -->
                <v-icon color="black"> mdi-alert </v-icon>
                <font color="black"
                  ><b>Sample contains at least one component out of limits.<br /></b
                ></font>
                 </div
              ><br />
              <div style="display: inline-flex"
                ><!-- <v-img
                height="15"
                width="15"
                :src="require('@/apps/limsds/images/nosample1.png')"
              ></v-img> -->
              
                 <v-icon  color="red"> mdi-cancel </v-icon>
              <font color="black"><b> Sample cancelled.</b></font>
              </div>
              <br />
              <div style="display: inline-flex"
                ><!-- <v-img
                height="15"
                width="15"
                :src="require('@/apps/limsds/images/partial1.png')"
              ></v-img> -->
                 <v-icon  color="blue"> mdi-circle-slice-6 </v-icon>
              <font color="black"
                ><b> Partial sample. Not all lab tests are complete.</b></font
              >
              </div>
          </v-tooltip>
          </v-col>
          <v-col sm="1" align="center" justify="center">
           <br />
            <v-dialog v-model="dialog" persistent max-width="400px">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <label class="LegendMenuItem">Save as favorite</label>
                </div>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Save Favorite</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="8">
                      <v-text-field
                        label="Favorite Name*"
                        required
                        dense
                        outlined
                        hide-details
                        v-model="favName"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="saveFavorite()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          
        </v-row>
        <v-card class="table_style">
            <v-data-table
              dense
              fixed-header
              class="elevation-5"
              :headers="Resultheaders"
              :items="resultList"
              item-key="s_Key"
              :loading="isLoading"
              loading-text="Loading... Please wait"
              :hide-default-footer="true"
              disable-pagination
            >
              <template v-slot:item.status="{ item }">
                <div v-if="item.status == 'nosample'">
                  <v-icon color="red" small> mdi-cancel </v-icon>
                </div>
                <div v-else-if="item.status == 'partial'">
                  <v-icon color="blue " small> mdi-circle-slice-6 </v-icon>
                </div>
              </template>
              <template v-slot:item.off_spec="{ item }">
                <div v-if="item.off_spec == 1">
                  <v-icon color="red" small>mdi-alert-outline </v-icon>
                </div>
              </template>
              <template v-slot:item.Point="{ item }">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="itemRowBackground(item)"
                    >
                      <a
                        :href="`/#/limsds/Sample-Detail?site=${item.site}&s_Key=${item.s_Key}`" @click="addVisited(item.s_Key)"
                      >
                        <font :class="itemRowBackground(item)"
                          ><b> {{ item.Point }}</b></font
                        ><br />
                      </a>
                    </div>
                  </template>
                  <span>
                    <span v-if="item.arrival_UTCtime != null">
                      <font
                        ><b>
                          Arrived : 
                          {{
                            convertUTCDateToLocalDate(
                              new Date(item.arrival_UTCtime)
                            ).toLocaleString()
                          }} CDT</b
                        ></font
                      ><br />
                    </span>
                    <span v-if="item.comment != null">
                      <font color="white"
                        ><b> Comment : {{ item.comment }}</b></font
                      ><br />
                    </span>
                    <span v-if="item.batch_id != null">
                      <font color="white"
                        ><b> Batch ID : {{ item.batch_id }}</b></font
                      ><br />
                    </span>
                    <span v-if="item.description != null">
                      <font color="white"
                        ><b> Description : {{ item.description }}</b></font
                      ><br />
                    </span>
                    <span v-if="item.status != null">
                      <font color="white"
                        ><b> Status : {{ item.status }}</b></font
                      ><br />
                    </span>
                    <span v-if="item.material_number != null">
                      <font color="white"
                        ><b>
                          Material Number : {{ item.material_number }}</b
                        ></font
                      ><br />
                    </span>
                    <span v-if="item.material_description != null">
                      <font color="white"
                        ><b>
                          Material Description :
                          {{ item.material_description }}</b
                        ></font
                      >
                    </span>
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:item.sample_time="{ item }">
                <div :class="itemRowBackground(item)">
                  {{ dateFormatConvertor(item) }}
                </div>
              </template>
            </v-data-table>
        </v-card>
      </div>
      <div v-show="displayMessage">
        <h3><b>The user favorite selected is not valid </b></h3>
        <h4><b>Please select valid favorite id ... </b></h4>
      </div>
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import uiView from "@/_mixins/ui-view-mixin";
import axios from "axios";
import SiteUnitAreaTree from "../components/SiteUnitAreaTree";
import appMixin from "../mixins/app-mixin";
export default {
  name: "SamplePointsArrival",
  mixins: [uiView, appMixin],

  components: {
    SiteUnitAreaTree,
  },
  props: {},
  watch: {
    selectedItem() {
      this.JsonToXml();
    },
  },
  computed: {},
  data() {
    return {
      showAll: true,
      displayMessage: false,
      siteList: undefined,
      dialog: false,
      favName: null,
      selectedFav: null,
      favoriteList: [],
      defaultValues: {
        DateFormat: null,
        limsInternal: null,
        completedonly: null,
        site: null,
      },
      selectedItem: null,
      updateItem: false,
      CurrentDateTime: moment().format("DD/MM/YYYY hh:mm:ss"),
      earlyDate: moment().add(-12, "hours").format("YYYY-MM-DD hh:mm:ss"),
      lateDate: moment().format("YYYY-MM-DD hh:mm:ss"),
      isLoading: false,
      Resultheaders: [
        {
          text: "",
          align: "center",
          width: "10px",
          value: "off_spec",
          sortable: false,
          class: "primary white--text",
        },
        {
          text: "",
          align: "center",
          width: "10px",
          value: "status",
          sortable: false,
          class: "primary white--text",
        },

        {
          text: "Sample Point",
          value: "Point",
          class: "primary white--text",
        },
        {
          text: "Sample Time",
          value: "sample_time",
          class: "primary white--text",
          
        },
        {
          text: "Sample Description",
          value: "description",
          class: "primary white--text",
        },
      ],
      list: [],
      resultList: [],
      partialXml: null,
      finalXml: null,
      UnitArea: null,
    };
  },
  mounted() {},
  created() {
    this.NewsLetter = this.settings.NewsLetter;
    this.HelpSearchByPoint = this.settings.HelpSearchByPoint;
    this.list = this.limsds_userPreference;
    this.defaultValues.DateFormat = this.list.Dateformat;
    this.defaultValues.limsInternal = this.list.Limsinternal;
    this.defaultValues.completedonly = this.list.Completedonly;
    this.defaultValues.site = this.list.site1;
    if (this.limsds_userDetails.userEmail != null) {
      this.Favorite();
      // let uri = window.location.href.split("?");
      // if (uri.length == 2) {
      //   let vars = uri[1].split("&");
      //   let getVars = {};
      //   let tmp = "";
      //   vars.forEach(function (v) {
      //     tmp = v.split("=");
      //     if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      //   });
      //   if (
      //     getVars.fav_id == "" ||
      //     getVars.fav_id == null ||
      //     getVars.fav_id == undefined
      //   ) {
      //     this.showAll = false;
      //     this.displayMessage = true;
      //   } else {
      //     const favList =
      //       this.settings.WAFavList +
      //       "userId=" +
      //       this.limsds_userDetails.userEmail +
      //       "&page_name=SRA";
      //     axios.get(favList).then((response) => {
      //       debugger
      //       let that = this;
      //       that.favoriteList = response.data.value;
      //       var fav_id = that.favoriteList.find(
      //         (x) => x.fav_id == getVars.fav_id
      //       )?.fav_id;
      //       if (fav_id == "" || fav_id == null || fav_id == undefined) {
      //         this.showAll = false;
      //         this.displayMessage = true;
      //       } else {
      //         that.selectedFav=fav_id;
      //         that.UnitArea = that.favoriteList.find(
      //           (x) => x.fav_id == fav_id
      //         )?.areas;
      //         that.defaultValues.site = that.favoriteList.find(
      //           (x) => x.fav_id == fav_id
      //         )?.site;
      //         if (that.UnitArea != null && that.defaultValues.site != null) {
      //           that.savePreference();
      //           that.fetchSampleListResult();
      //         }
      //       }
      //     });
      //   }
      // }
    }
  },
  methods: {
    convertUTCDateToLocalDate(date) {
      var newDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60 * 1000
      );

      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();

      newDate.setHours(hours - offset);

      return newDate;
    },
    dateFormatConvertor: function (item) {
      if (item.sample_time != "" || item.sample_time != null) {
        return moment(item.sample_time).format("DD/MM/YYYY hh:mm:ss");
      } else {
        return "";
      }
    },
    fillBySelectedFav() {
      this.UnitArea = this.favoriteList.find(
        (x) => x.fav_id == this.selectedFav
      )?.areas;
      this.defaultValues.site = this.favoriteList.find(
        (x) => x.fav_id == this.selectedFav
      )?.site;
      this.savePreference();
      this.fetchSampleListResult();
      
      //this.UserPreference();
      //window.location.href =
        //"/#/limsds/Sample-Arrival?fav_id=" + this.selectedFav;

       //window.location.reload();
    },
    UserPreference() {
      let that = this;
      const link =
        this.settings.WAPreferenceByUser +
        "UserID=" +
        this.limsds_userDetails.userEmail;
      axios
        .get(link)
        .then((response) => {
          that.limsds_userPreference = response.data.value[0];
          this.updateItem = !this.updateItem;
          //console.log("userpref",that.limsds_userPreference);
        })
        .catch((error) => {
          this.$root.$refs.UIError.UserPreference(
            "Preference",
            "method",
            error
          );
        });
    },
    Favorite() {
      let that = this;
      const favList =
        this.settings.WAFavList +
        "userId=" +
        this.limsds_userDetails.userEmail +
        "&page_name=SPRA";
      axios.get(favList).then((response) => {
        that.favoriteList = response.data.value;
      });
    },
    saveFavorite() {
      const saveFav =
        this.settings.WASaveFav +
        "fav_name=" +
        this.favName +
        "&userId=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.defaultValues.site +
        "&areas=" +
        this.UnitArea +
        "&page_name=SPRA";
      axios.get(saveFav).then((response) => {
        this.favoriteList = response.data.value;
        //this.Favorite();
      });
      this.dialog = false;
    },
    itemOffSpecImage: function (item) {
      if (item.off_spec != 0) {
        return require("@/apps/limsds/images/warningsign1.png");
      } else {
        return "";
      }
    },
    itemImage: function (item) {
      if (item.status == "nosample") {
        return require("@/apps/limsds/images/nosample1.png");
      } else if (item.status == "partial") {
        return require("@/apps/limsds/images/partial1.png");
      } else {
        return "";
      }
    },
    itemRowBackground: function (item) {
      var arrivalTime = moment
        .utc(item.arrival_UTCtime.slice(0, -6))
        .diff(moment.utc(), "minutes");
      if(this.limsds_saVisited.includes(item.s_Key)){
        return "visitedLegend";
      }else{
        if (arrivalTime > -60) {
          return "NewArrivalsLegend";
        } else if (arrivalTime > -120) {
          return "OldArrivalsLegend";
        } else {
          return "OlderArrivalsLegend";
        }
      }
      
    },
    siteUpdate(site) {
      this.defaultValues.site = site;
    },
    JsonToXml() {
      let that = this;
      if (that.selectedItem.length > 0) {
        const JsonToXml =
          that.settings.WAJsonToXml +
          "userid=" +
          that.limsds_userDetails.userEmail +
          "&JsonString=" +
          that.selectedItem;
        axios.get(JsonToXml).then((response) => {
          that.UnitArea = response.data[0].result;
          if (that.UnitArea != null) {
            that.fetchSampleListResult();
          }
        });
      }
    },
    fetchSampleListResult() {
      //debugger
      let that = this;
      that.isLoading = true;
      const SamplePointArrival =
        that.settings.WASamplePointArrival +
        "earlytime=" +
        this.earlyDate +
        "&userid=" +
        that.limsds_userDetails.userEmail +
        "&Site=" +
        that.defaultValues.site +
        "&Unitarea=" +
        that.UnitArea +
        "&lims_internal=" +
        that.defaultValues.limsInternal +
        "&complete_only=" +
        that.defaultValues.completedonly;
      axios
        .get(SamplePointArrival)
        .then((response) => {
          that.resultList = response.data.value;
          that.isLoading = false;
          that.savePreference();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          that.isLoading = false;
          setTimeout(function () {
            window.location.reload(1);
          }, 120000);
          setTimeout(() => that.fetchSampleListResult(), 120 * 1000);
        });
    },
    savePreference() {
      let that = this;
      const SavePref =
        that.settings.WASavePref +
        "site=" +
        that.defaultValues.site +
        "&userid=" +
        that.limsds_userDetails.userEmail +
        "&Area=" +
        that.UnitArea;
      axios.get(SavePref).then((response) => {
        
       this.UserPreference();
      });
    },
    addVisited(sKey){
      this.limsds_saVisited.indexOf(sKey) === -1 ? this.limsds_saVisited.push(sKey) : console.log("keyExist");     
    },
  },
};
</script>
<style lang="scss">
.v-tooltip__content {
  font-size: 15px !important;
  opacity: 1 !important;
  //background-color: white;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control, .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    min-height: 24px;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 3px;
}
.v-text-field__slot {
    padding: 0px !important;
}

.table_style  .v-data-table--fixed-header > .v-data-table__wrapper{
 overflow: hidden;
}
.table_style .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .table_style .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .table_style .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.875rem;
    height: 8px !important;
    padding: 0 2px !important;
}
.v-data-table {
    line-height: 1;
    max-width: 100%;
}
.table_style 
{width : auto; display : inline-block}
</style>
